"use client"

import { useEffect, useState } from "react"

export default function AgeGate() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    try {
      if (localStorage.getItem("ivx_age_ok") !== "1") setShow(true)
    } catch (e) {
      setShow(true)
    }
  }, [])

  if (!show) return null

  const accept = () => {
    try {
      localStorage.setItem("ivx_age_ok", "1")
    } catch (e) {}
    setShow(false)
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 100000,
        background: "rgba(0,0,0,.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Poppins, Lato, system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          color: "#1d1d1d",
          maxWidth: 440,
          width: "92%",
          borderRadius: 10,
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,.5)",
        }}
      >
        <div style={{ height: 6, background: "linear-gradient(90deg,#54d0a0,#334fb4)" }} />
        <div style={{ padding: "34px 30px 26px", textAlign: "center" }}>
          <h2 style={{ margin: "0 0 14px", fontSize: 26, fontWeight: 700 }}>Age Verification</h2>
          <p style={{ margin: "0 0 22px", color: "#5d5d5d", fontSize: 15, lineHeight: 1.5 }}>
            You must be 21 or older to visit this website. Your age will be verified at checkout.
          </p>
          <button
            onClick={accept}
            style={{
              background: "linear-gradient(90deg,#3ecf8e,#2fb37a)",
              color: "#fff",
              border: 0,
              borderRadius: 6,
              padding: "13px 26px",
              fontSize: 15,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            I&apos;m 21 or older &rsaquo;
          </button>
          <div style={{ marginTop: 16 }}>
            <a href="/pages/faq" style={{ color: "#334fb4", fontSize: 13, textDecoration: "none" }}>
              Age Verification FAQ
            </a>
          </div>
        </div>
        <div
          style={{
            padding: 16,
            background: "#f6f7f9",
            textAlign: "center",
            color: "#8a8a8a",
            fontSize: 13,
            borderTop: "1px solid #eee",
          }}
        >
          Adult use only — 21+
        </div>
      </div>
    </div>
  )
}
